<template>
  <div class="ColorMgmt">
    <div class="header-box">
      <div class="header-line">
        <el-button type="primary" size="small" @click="getColors">查询</el-button>
        <el-button type="primary" size="small" @click="addColor">新增</el-button>
      </div>
    </div>
    <el-table ref="table" :data="colors" border size="small" :height="screenHeight">
      <el-table-column label="序号" width="50px" align="right">
        <template slot-scope="scope">
          {{ beginIndex + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="颜色名称" width="150px"> </el-table-column>
      <el-table-column prop="usName" label="英文颜色名" width="150px"> </el-table-column>
      <el-table-column prop="key" label="英文关键字" width="150px"> </el-table-column>
      <el-table-column prop="jpKey" label="日文关键字" width="150px"> </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="editColor(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog width="450px" title="新增颜色" :visible.sync="colorDialogVisible" append-to-body>
      <div class="form-line">
        <span class="form-label"><span>*</span>颜色名称</span>
        <el-input class="form-input" placeholder="请输入" v-model="colorInfo.name" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>英文颜色名称</span>
        <el-input class="form-input" placeholder="请输入" v-model="colorInfo.usName" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
      </div>
      <div class="form-line">
        <span class="form-label"><span>*</span>英文关键字</span>
        <el-input class="form-input" placeholder="请输入" v-model="colorInfo.key" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
      </div>

      <div class="form-line">
        <span class="form-label"><span>*</span>日文关键字</span>
        <el-input class="form-input" placeholder="请输入" v-model="colorInfo.jpKey" size="small" style="width: 300px; vertical-align: middle" clearable> </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="colorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleColorConfirmBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { colors, models, iPhoneModels, products, getPhoneCaseContantInfo } from "../../utils/constant.js";
export default {
  data() {
    return {
      configMaterialDialogVisible: false,
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      beginIndex: 0,
      colorDialogVisible: false,
      colorInfo: { name: "", usName: "", key: "", jpKey: "" },
      colors: colors,
    };
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    getColors() {
      getPhoneCaseContantInfo();
    },
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
    },
    addColor() {
      this.colorDialogVisible = true;
      this.colorInfo = {
        name: "",
        usName: "",
        key: "",
        jpKey: "",
      };
    },
    editColor(row) {
      this.colorDialogVisible = true;
      this.colorInfo = {
        ...row,
      };
    },
    deleteColor(row) {},
    handleColorConfirmBtn() {
      if (this.colorInfo.name == null || this.colorInfo.key == "") {
        this.$message({
          type: "error",
          message: "请输入完整颜色信息",
        });
        return;
      }

      requestModules
        .addColor(this.colorInfo)
        .then(res => {
          if (res.result !== 1) {
            this.$message({
              type: "error",
              message: res.message ? res.message : "新增失败",
            });
            return;
          }

          this.colorDialogVisible = false;
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          getPhoneCaseContantInfo();
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.ColorMgmt {
  padding-left: 20px;
  background-color: white;
  .redText {
    color: red;
  }
  .no-padding {
    padding: 0px !important;
    .cell {
      padding: 0px !important;
    }
  }
  .form-line {
    height: 40px;
    line-height: 40px;

    .form-label {
      margin: 5px 10px 5px 0px;
      width: 110px;
      text-align: right;
      display: inline-block;
      span {
        color: red;
      }
    }
    .form-input {
      width: 800px;
      margin: 5px 0px;
      vertical-align: top;
    }
    .form-group {
      width: 750px;
      margin: 5px 0px;
      display: inline-block;
      vertical-align: top;

      .el-checkbox {
        width: 70px;
      }
    }
  }
}
.form-line {
  .form-label {
    margin: 5px 10px 5px 0px;
    width: 100px;
    text-align: right;
    display: inline-block;
    span {
      color: red;
    }
  }
  .form-input {
    width: 800px;
    margin: 5px 0px;
    vertical-align: top;
  }
  .form-group {
    width: 750px;
    margin: 5px 0px;
    display: inline-block;
    vertical-align: top;

    .el-checkbox {
      width: 70px;
    }
    .el-radio {
      width: 70px;
    }
  }
}
</style>
